// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode CSS Variables and Styles */
:root {
  /* Light mode colors */
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --bg-tertiary: #e9ecef;
  --text-primary: #212529;
  --text-secondary: #6c757d;
  --text-muted: #adb5bd;
  --border-color: #dee2e6;
  --navbar-bg: #343a40;
  --navbar-text: #ffffff;
  --table-hover: #f5f5f5;
  --skeleton-bg: #e9ecef;
  --skeleton-shine: #f4f4f4;
}

.dark-mode {
  /* Dark mode colors */
  --bg-primary: #1a1a1a;
  --bg-secondary: #2d2d2d;
  --bg-tertiary: #3a3a3a;
  --text-primary: #e0e0e0;
  --text-secondary: #b0b0b0;
  --text-muted: #808080;
  --border-color: #404040;
  --navbar-bg: #000000;
  --navbar-text: #e0e0e0;
  --table-hover: #2a2a2a;
  --skeleton-bg: #3a3a3a;
  --skeleton-shine: #4a4a4a;
}

/* Base styles using CSS variables */
body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Navbar */
.dark-mode .navbar-dark,
.dark-mode .navbar {
  background: var(--navbar-bg) !important;
  background-color: var(--navbar-bg) !important;
  background-image: none !important;
}

.dark-mode .navbar * {
  background-image: none !important;
}

.dark-mode .navbar-brand {
  color: var(--navbar-text) !important;
}

.dark-mode .navbar .container {
  background: transparent !important;
  background-color: transparent !important;
}

.dark-mode .navbar .bg-secondary {
  background-color: var(--navbar-bg) !important;
}

.dark-mode .navbar .flex-wrap {
  background-color: var(--navbar-bg) !important;
}

.dark-mode .flex-column {
  background-color: var(--navbar-bg) !important;
}

/* Container and cards */
.dark-mode .container {
  background-color: var(--bg-primary);
}

.dark-mode .card {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

/* Tables */
.dark-mode .table {
  color: var(--text-primary);
  border-color: var(--border-color);
}

.dark-mode .table-striped tbody tr:nth-of-type(odd) {
  background-color: var(--bg-tertiary);
}

.dark-mode .table-hover tbody tr:hover {
  background-color: var(--table-hover);
  color: var(--text-primary);
}

.dark-mode .table thead th {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.dark-mode .table td {
  border-color: var(--border-color);
}

/* Form controls */
.dark-mode .form-control,
.dark-mode .form-select {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.dark-mode .form-control:focus,
.dark-mode .form-select:focus {
  background-color: var(--bg-secondary);
  border-color: #0d6efd;
  color: var(--text-primary);
}

/* Buttons */
.dark-mode .btn-outline-primary {
  color: #4dabf7;
  border-color: #4dabf7;
}

.dark-mode .btn-outline-primary:hover {
  background-color: #4dabf7;
  border-color: #4dabf7;
  color: #000;
}

.dark-mode .btn-outline-secondary {
  color: var(--text-secondary);
  border-color: var(--border-color);
}

.dark-mode .btn-outline-secondary:hover {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

/* Badges */
.dark-mode .badge.bg-secondary {
  background-color: var(--bg-tertiary) !important;
  color: var(--text-primary) !important;
}

.dark-mode .badge.bg-light {
  background-color: var(--bg-secondary) !important;
  color: var(--text-primary) !important;
}

/* Modal and takeover */
.dark-mode .modal-content {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

.dark-mode .modal-header {
  border-color: var(--border-color);
}

.dark-mode .modal-footer {
  border-color: var(--border-color);
}

.dark-mode .best-bets-takeover {
  background-color: var(--bg-primary) !important;
}

.dark-mode .best-bets-takeover-body {
  background-color: var(--bg-secondary) !important;
}

/* DataTable specific */
.dark-mode .table-container {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.dark-mode .table-group {
  background-color: var(--bg-secondary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-mode .table th {
  background: linear-gradient(135deg, var(--bg-tertiary) 0%, var(--bg-secondary) 100%);
  color: var(--text-primary);
  border-color: var(--border-color);
}

.dark-mode .table tbody tr:hover {
  background-color: rgba(79, 172, 254, 0.1);
}

.dark-mode .odds-cell {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

.dark-mode .odds-cell:hover {
  background-color: var(--bg-tertiary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.dark-mode .game-header,
.dark-mode .game-header-container {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  border-color: var(--border-color);
}

.dark-mode .player-name-cell,
.dark-mode .player-name-cell-no-logo {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

.dark-mode .live-badge {
  background-color: #28a745 !important;
  color: #fff !important;
}

/* Best bets specific */
.dark-mode .best-bet-list-item {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

.dark-mode .best-bet-list-item:nth-child(even) {
  background-color: #404040;
}

.dark-mode .best-bet-list-item:hover {
  background-color: var(--bg-primary);
}

.dark-mode .best-bet-card {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

/* Edge-three tier dark mode support */
.dark-mode .best-bets-badge.tier-edge-three {
  background-color: #4F46E5 !important;
  color: white !important;
}

.dark-mode .best-bet-card.tier-edge-three .odds-item.best-book {
  background-color: #4F46E5;
  color: white;
}

.dark-mode .expanded-odds-item.best-book.edge-three {
  border-color: #4F46E5;
  background: rgba(79, 70, 229, 0.1);
}

.dark-mode .expanded-odds-item.best-book.edge-three span {
  color: #A5B4FC;
}

/* Dark mode: Grey tier appears as blue 
.dark-mode .best-bet-list-item.tier-edge-three .best-odds {
  background-color: #4F46E5 !important;
}
*/
.dark-mode .best-bet-list-item .best-odds .odds-value,
.dark-mode .best-bet-list-item .next-best-section .odds-value {
  color: white !important;
}

.dark-mode .best-bet-list-item.tier-edge-three .best-odds .odds-value {
  color: white;
}

.dark-mode .best-bet-card.tier-edge-three .best-odds .odds-value {
  color: white;
}

/* DataTable edge-three tier dark mode */
.dark-mode .best-bets-odds-cell.best-book-cell-edge-three-dark {
  background-color: #4F46E5 !important;
  color: white !important;
}

.dark-mode .odds-item {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
}

.dark-mode .expanded-odds-item {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
}

/* Skeleton loading */
.dark-mode .skeleton-player,
.dark-mode .skeleton-odds {
  background-color: var(--skeleton-bg);
}

.dark-mode .skeleton-player::after,
.dark-mode .skeleton-odds::after {
  background: linear-gradient(90deg, transparent, var(--skeleton-shine), transparent);
}

/* Text colors */
.dark-mode .text-muted {
  color: var(--text-muted) !important;
}

.dark-mode .text-secondary {
  color: var(--text-secondary) !important;
}

/* Market selection badges */
.dark-mode .market-badge-small {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
}

/* Footer */
.dark-mode .app-footer {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
  color: var(--text-secondary);
}

/* Additional DataTable dark mode fixes */
.dark-mode .table tbody tr {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.dark-mode .table tbody tr:nth-of-type(odd) {
  background-color: var(--bg-secondary);
}

.dark-mode .table td {
  background-color: inherit;
  color: var(--text-primary);
  border-color: var(--border-color);
}

/* Skeleton loading for dark mode */
.dark-mode .skeleton-text {
  background: linear-gradient(90deg, var(--skeleton-bg) 25%, var(--skeleton-shine) 50%, var(--skeleton-bg) 75%);
}

.dark-mode .skeleton-odds {
  background: linear-gradient(90deg, var(--skeleton-bg) 25%, var(--skeleton-shine) 50%, var(--skeleton-bg) 75%);
}

/* Game navigation badges */
.dark-mode .game-badge {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  border-color: var(--border-color);
}

.dark-mode .game-badge:hover {
  background-color: var(--bg-primary);
}

/* Mobile select dropdown */
.dark-mode .form-select option {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

/* Last updated */
.dark-mode .last-updated {
  color: var(--text-secondary);
}

/* Player Modal dark mode */
.dark-mode .player-modal .modal-content {
  background-color: var(--bg-secondary);
  color: var(--text-primary);
}

.dark-mode .player-modal .modal-body {
  background-color: var(--bg-primary);
}

.dark-mode .player-modal .card {
  background-color: var(--bg-secondary);
  border-color: var(--border-color);
}

.dark-mode .player-modal .table-dark {
  background-color: var(--bg-tertiary);
}

.dark-mode .player-modal canvas {
  background-color: var(--bg-secondary);
}

/* Badge overrides for dark mode */
.dark-mode .badge.bg-light {
  background-color: var(--bg-tertiary) !important;
  color: var(--text-primary) !important;
  border-color: var(--border-color) !important;
}

.dark-mode .badge.bg-info {
  background-color: #0dcaf0 !important;
  color: #000 !important;
}

/* Any remaining white backgrounds */
.dark-mode div[style*="background: white"],
.dark-mode div[style*="background-color: white"] {
  background-color: var(--bg-secondary) !important;
}

/* Ensure all text is properly colored */
.dark-mode * {
  border-color: var(--border-color);
}

.dark-mode .text-dark {
  color: var(--text-primary) !important;
}

.dark-mode .bg-white {
  background-color: var(--bg-secondary) !important;
}

.dark-mode .bg-light {
  background-color: var(--bg-tertiary) !important;
}

/* Alert */
.dark-mode .alert-warning {
  background-color: #664d03;
  border-color: #997404;
  color: #ffca2c;
}

/* Book selector */
.dark-mode .book-selector {
  background-color: var(--bg-tertiary);
}

.dark-mode .book-selector.selected {
  background-color: rgba(13, 110, 253, 0.2);
  border-color: #0d6efd;
}

/* Toggle switch for dark mode */
.dark-mode-toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  margin: 0 10px;
}

.dark-mode-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.dark-mode-toggle .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.dark-mode-toggle .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

.dark-mode-toggle input:checked + .slider {
  background-color: #0d6efd;
}

.dark-mode-toggle input:checked + .slider:before {
  transform: translateX(26px);
}

/* Icons for light/dark mode */
.theme-icon {
  font-size: 1.2rem;
  vertical-align: middle;
}

.light-icon {
  color: #ffc107;
}

.dark-icon {
  color: #6c757d;
}`, "",{"version":3,"sources":["webpack://./src/styles/DarkMode.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,WAAW;AACX;;EAEE,uCAAuC;EACvC,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;;EAEE,qCAAqC;EACrC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,oFAAoF;EACpF,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;;EAEE,oCAAoC;EACpC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;CAIC;AACD;;EAEE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,mFAAmF;AACrF;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,mCAAmC;AACnC;EACE,6GAA6G;AAC/G;;AAEA;EACE,6GAA6G;AAC/G;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,+CAA+C;EAC/C,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;;EAEE,gDAAgD;AAClD;;AAEA,wCAAwC;AACxC;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Dark Mode CSS Variables and Styles */\n:root {\n  /* Light mode colors */\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8f9fa;\n  --bg-tertiary: #e9ecef;\n  --text-primary: #212529;\n  --text-secondary: #6c757d;\n  --text-muted: #adb5bd;\n  --border-color: #dee2e6;\n  --navbar-bg: #343a40;\n  --navbar-text: #ffffff;\n  --table-hover: #f5f5f5;\n  --skeleton-bg: #e9ecef;\n  --skeleton-shine: #f4f4f4;\n}\n\n.dark-mode {\n  /* Dark mode colors */\n  --bg-primary: #1a1a1a;\n  --bg-secondary: #2d2d2d;\n  --bg-tertiary: #3a3a3a;\n  --text-primary: #e0e0e0;\n  --text-secondary: #b0b0b0;\n  --text-muted: #808080;\n  --border-color: #404040;\n  --navbar-bg: #000000;\n  --navbar-text: #e0e0e0;\n  --table-hover: #2a2a2a;\n  --skeleton-bg: #3a3a3a;\n  --skeleton-shine: #4a4a4a;\n}\n\n/* Base styles using CSS variables */\nbody {\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Navbar */\n.dark-mode .navbar-dark,\n.dark-mode .navbar {\n  background: var(--navbar-bg) !important;\n  background-color: var(--navbar-bg) !important;\n  background-image: none !important;\n}\n\n.dark-mode .navbar * {\n  background-image: none !important;\n}\n\n.dark-mode .navbar-brand {\n  color: var(--navbar-text) !important;\n}\n\n.dark-mode .navbar .container {\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.dark-mode .navbar .bg-secondary {\n  background-color: var(--navbar-bg) !important;\n}\n\n.dark-mode .navbar .flex-wrap {\n  background-color: var(--navbar-bg) !important;\n}\n\n.dark-mode .flex-column {\n  background-color: var(--navbar-bg) !important;\n}\n\n/* Container and cards */\n.dark-mode .container {\n  background-color: var(--bg-primary);\n}\n\n.dark-mode .card {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n\n/* Tables */\n.dark-mode .table {\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .table-striped tbody tr:nth-of-type(odd) {\n  background-color: var(--bg-tertiary);\n}\n\n.dark-mode .table-hover tbody tr:hover {\n  background-color: var(--table-hover);\n  color: var(--text-primary);\n}\n\n.dark-mode .table thead th {\n  background-color: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n.dark-mode .table td {\n  border-color: var(--border-color);\n}\n\n/* Form controls */\n.dark-mode .form-control,\n.dark-mode .form-select {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n.dark-mode .form-control:focus,\n.dark-mode .form-select:focus {\n  background-color: var(--bg-secondary);\n  border-color: #0d6efd;\n  color: var(--text-primary);\n}\n\n/* Buttons */\n.dark-mode .btn-outline-primary {\n  color: #4dabf7;\n  border-color: #4dabf7;\n}\n\n.dark-mode .btn-outline-primary:hover {\n  background-color: #4dabf7;\n  border-color: #4dabf7;\n  color: #000;\n}\n\n.dark-mode .btn-outline-secondary {\n  color: var(--text-secondary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .btn-outline-secondary:hover {\n  background-color: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n/* Badges */\n.dark-mode .badge.bg-secondary {\n  background-color: var(--bg-tertiary) !important;\n  color: var(--text-primary) !important;\n}\n\n.dark-mode .badge.bg-light {\n  background-color: var(--bg-secondary) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Modal and takeover */\n.dark-mode .modal-content {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.dark-mode .modal-header {\n  border-color: var(--border-color);\n}\n\n.dark-mode .modal-footer {\n  border-color: var(--border-color);\n}\n\n.dark-mode .best-bets-takeover {\n  background-color: var(--bg-primary) !important;\n}\n\n.dark-mode .best-bets-takeover-body {\n  background-color: var(--bg-secondary) !important;\n}\n\n/* DataTable specific */\n.dark-mode .table-container {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.dark-mode .table-group {\n  background-color: var(--bg-secondary);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.dark-mode .table th {\n  background: linear-gradient(135deg, var(--bg-tertiary) 0%, var(--bg-secondary) 100%);\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .table tbody tr:hover {\n  background-color: rgba(79, 172, 254, 0.1);\n}\n\n.dark-mode .odds-cell {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.dark-mode .odds-cell:hover {\n  background-color: var(--bg-tertiary);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.dark-mode .game-header,\n.dark-mode .game-header-container {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .player-name-cell,\n.dark-mode .player-name-cell-no-logo {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.dark-mode .live-badge {\n  background-color: #28a745 !important;\n  color: #fff !important;\n}\n\n/* Best bets specific */\n.dark-mode .best-bet-list-item {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .best-bet-list-item:nth-child(even) {\n  background-color: #404040;\n}\n\n.dark-mode .best-bet-list-item:hover {\n  background-color: var(--bg-primary);\n}\n\n.dark-mode .best-bet-card {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n\n/* Edge-three tier dark mode support */\n.dark-mode .best-bets-badge.tier-edge-three {\n  background-color: #4F46E5 !important;\n  color: white !important;\n}\n\n.dark-mode .best-bet-card.tier-edge-three .odds-item.best-book {\n  background-color: #4F46E5;\n  color: white;\n}\n\n.dark-mode .expanded-odds-item.best-book.edge-three {\n  border-color: #4F46E5;\n  background: rgba(79, 70, 229, 0.1);\n}\n\n.dark-mode .expanded-odds-item.best-book.edge-three span {\n  color: #A5B4FC;\n}\n\n/* Dark mode: Grey tier appears as blue \n.dark-mode .best-bet-list-item.tier-edge-three .best-odds {\n  background-color: #4F46E5 !important;\n}\n*/\n.dark-mode .best-bet-list-item .best-odds .odds-value,\n.dark-mode .best-bet-list-item .next-best-section .odds-value {\n  color: white !important;\n}\n\n.dark-mode .best-bet-list-item.tier-edge-three .best-odds .odds-value {\n  color: white;\n}\n\n.dark-mode .best-bet-card.tier-edge-three .best-odds .odds-value {\n  color: white;\n}\n\n/* DataTable edge-three tier dark mode */\n.dark-mode .best-bets-odds-cell.best-book-cell-edge-three-dark {\n  background-color: #4F46E5 !important;\n  color: white !important;\n}\n\n.dark-mode .odds-item {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.dark-mode .expanded-odds-item {\n  background-color: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n/* Skeleton loading */\n.dark-mode .skeleton-player,\n.dark-mode .skeleton-odds {\n  background-color: var(--skeleton-bg);\n}\n\n.dark-mode .skeleton-player::after,\n.dark-mode .skeleton-odds::after {\n  background: linear-gradient(90deg, transparent, var(--skeleton-shine), transparent);\n}\n\n/* Text colors */\n.dark-mode .text-muted {\n  color: var(--text-muted) !important;\n}\n\n.dark-mode .text-secondary {\n  color: var(--text-secondary) !important;\n}\n\n/* Market selection badges */\n.dark-mode .market-badge-small {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n/* Footer */\n.dark-mode .app-footer {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n  color: var(--text-secondary);\n}\n\n/* Additional DataTable dark mode fixes */\n.dark-mode .table tbody tr {\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.dark-mode .table tbody tr:nth-of-type(odd) {\n  background-color: var(--bg-secondary);\n}\n\n.dark-mode .table td {\n  background-color: inherit;\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n/* Skeleton loading for dark mode */\n.dark-mode .skeleton-text {\n  background: linear-gradient(90deg, var(--skeleton-bg) 25%, var(--skeleton-shine) 50%, var(--skeleton-bg) 75%);\n}\n\n.dark-mode .skeleton-odds {\n  background: linear-gradient(90deg, var(--skeleton-bg) 25%, var(--skeleton-shine) 50%, var(--skeleton-bg) 75%);\n}\n\n/* Game navigation badges */\n.dark-mode .game-badge {\n  background-color: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .game-badge:hover {\n  background-color: var(--bg-primary);\n}\n\n/* Mobile select dropdown */\n.dark-mode .form-select option {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n/* Last updated */\n.dark-mode .last-updated {\n  color: var(--text-secondary);\n}\n\n/* Player Modal dark mode */\n.dark-mode .player-modal .modal-content {\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.dark-mode .player-modal .modal-body {\n  background-color: var(--bg-primary);\n}\n\n.dark-mode .player-modal .card {\n  background-color: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n\n.dark-mode .player-modal .table-dark {\n  background-color: var(--bg-tertiary);\n}\n\n.dark-mode .player-modal canvas {\n  background-color: var(--bg-secondary);\n}\n\n/* Badge overrides for dark mode */\n.dark-mode .badge.bg-light {\n  background-color: var(--bg-tertiary) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border-color) !important;\n}\n\n.dark-mode .badge.bg-info {\n  background-color: #0dcaf0 !important;\n  color: #000 !important;\n}\n\n/* Any remaining white backgrounds */\n.dark-mode div[style*=\"background: white\"],\n.dark-mode div[style*=\"background-color: white\"] {\n  background-color: var(--bg-secondary) !important;\n}\n\n/* Ensure all text is properly colored */\n.dark-mode * {\n  border-color: var(--border-color);\n}\n\n.dark-mode .text-dark {\n  color: var(--text-primary) !important;\n}\n\n.dark-mode .bg-white {\n  background-color: var(--bg-secondary) !important;\n}\n\n.dark-mode .bg-light {\n  background-color: var(--bg-tertiary) !important;\n}\n\n/* Alert */\n.dark-mode .alert-warning {\n  background-color: #664d03;\n  border-color: #997404;\n  color: #ffca2c;\n}\n\n/* Book selector */\n.dark-mode .book-selector {\n  background-color: var(--bg-tertiary);\n}\n\n.dark-mode .book-selector.selected {\n  background-color: rgba(13, 110, 253, 0.2);\n  border-color: #0d6efd;\n}\n\n/* Toggle switch for dark mode */\n.dark-mode-toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n  margin: 0 10px;\n}\n\n.dark-mode-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.dark-mode-toggle .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 34px;\n}\n\n.dark-mode-toggle .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\n.dark-mode-toggle input:checked + .slider {\n  background-color: #0d6efd;\n}\n\n.dark-mode-toggle input:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n/* Icons for light/dark mode */\n.theme-icon {\n  font-size: 1.2rem;\n  vertical-align: middle;\n}\n\n.light-icon {\n  color: #ffc107;\n}\n\n.dark-icon {\n  color: #6c757d;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
